export default __webpack_public_path__ + "static/media/taiPOS.41686ddf.png";